import { Delete } from '@material-ui/icons'
import styled, { css } from 'styled-components'

import { Colors, FontSize } from '~/styles'

export const Wrapper = styled.div`
    ${(p) => p.type === 'background' &&
    css`
      width: 100%;
      display: flex;
      padding: 16px;
      border-radius:6px;
      height: min-content;
      flex-direction: column;
      background:${Colors.sandGray};
    `
  }
    ${(p) => p.scrollable &&
    css`
      max-height: 230px;
      overflow-y: scroll;
      overflow-x: hidden;
    `
  }
`

export const ListItem = styled.div`
  width:${(p) => p.fullWidth ? '100%' : p.fullWidth == 90 ? '400px' : p.fullWidth == '90%' ? '90%' : '450px'};
  display: flex;
  padding: 12px;
  border-radius:6px;
  flex-direction: row;
  align-items: center;
  background:${Colors.white};
`

export const WrapperList = styled.div`
  display: flex;
  margin-top:${(p) => p.type == 'list-item' ? '20' : ''}px;
  flex-direction: row;
  align-items: center;
  justify-content:space-between;

  &.mt-0 {
    margin-top: 0!important;
  }
`

export const WrapperColumn = styled.div`
  display: flex;
  color:${Colors.black};
  flex-direction: column;
  justify-content: space-between;
  margin-left:8px;
  font-size:${FontSize.mediumLarge}px;
`
export const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${(p) => p.type === 'ocr' ? 'space-between' : 'unset'};
`
export const WrapperRowSpace = styled.div`
  width:100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`

export const Description = styled.span`
  font-weight: 600;
  font-size: ${FontSize.small}px;
  margin-right: ${(p) => p.type === 'time' ? '5' : '0'}px;
  cursor: ${(p) => p.cursor === 'pointer' ? 'pointer' : 'cursor'};
  color: ${(p) => p.cursor === 'pointer' ? Colors.black : Colors.modalGrey};
`
export const IconGroup = styled.div`
  display: flex;
  margin-right: 8px;
  flex-direction: row;
`
export const Image = styled.img`
  user-select: none;
  cursor:${(p) => p.size == 'xl' ? 'cursor'
  : p.size == 'md' ? 'pointer' : 'cursor'};
  width: ${(p) => p.size == 'xl' ? '2.5'
  : p.size == 'md' ? '1.5' : '1'}em;
  height: ${(p) => p.size == 'xl' ? '2.5'
  : p.size == 'md' ? '1.5' : '1'}em;
  margin-right:${(p) => p.size == 'xl' ? '8'
  : p.size == 'md' ? '0' : '8'}px;
`
export const ContainerDel = styled.div`
  width: 40px;
  padding-left: 15px;
  text-align: center;
`
export const FileTitle = styled.p`
  cursor: pointer;
  font-weight: 600;
  color: ${Colors.cancelTextColor};
  font-size: ${FontSize.mediumMiddle}px;
`

export const DeleteIcon = styled(Delete)`
  color: ${(p) => p.type == 'delete' ? Colors.red : Colors.grayDisable};
  cursor: ${(p) => p.type == 'delete' ? 'pointer' : 'cursor'};
`

export const OCRLabel = styled.div`
  height: 24px;
  margin: 15px 0;
  font-size: 14px;
  padding: 2px 16px;
  border: 1px solid;
  font-weight: bold;
  border-radius: 24px;
  text-transform: capitalize;
  color: ${(p) => p.status === 'read' ? Colors.enhancedBlue : Colors.enhancedGreen};
  border-color: ${(p) => p.status === 'read' ? Colors.enhancedBlue : Colors.enhancedGreen};
  background-color: ${(p) => p.status === 'read' ? Colors.quiteSoftBlue : Colors.quiteSoftGreen};
`

export const LoadingWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  margin-left: 8px;
  align-items: center;
  justify-content: center;
`

export default {
  Image,
  Wrapper,
  ListItem,
  OCRLabel,
  IconGroup,
  FileTitle,
  DeleteIcon,
  WrapperRow,
  WrapperList,
  Description,
  ContainerDel,
  WrapperColumn,
  LoadingWrapper,
  WrapperRowSpace,
}